// Com a versão atual não é possivel importar direto pelo webpack
require('angular-bootstrap-toggle/dist/angular-bootstrap-toggle');
module.exports = 'ui.toggle'